/**
 * Tema Tankef compartido para `react-day-picker` v9. Usado por `DateInput`
 * (single date) y `DateRangePicker` (rango) para que ambos calendarios se
 * vean idénticos — un solo lugar que tocar si cambian los tokens de color.
 */
export const TANKEF_DAYPICKER_CLASS = 'tankef-rdp';

export const TANKEF_DAYPICKER_THEME_CSS = `
  .tankef-rdp.rdp-root {
    --rdp-accent-color: var(--tkf-line-focus);
    --rdp-accent-background-color: color-mix(in srgb, var(--tkf-line-focus) 14%, transparent);
    --rdp-day-height: 40px;
    --rdp-day-width: 40px;
    --rdp-day_button-height: 36px;
    --rdp-day_button-width: 36px;
    --rdp-day_button-border-radius: 6px;
    --rdp-months-gap: 2rem;
    --rdp-nav_button-height: 28px;
    --rdp-nav_button-width: 28px;
    --rdp-range_start-date-background-color: var(--tkf-line-focus);
    --rdp-range_end-date-background-color: var(--tkf-line-focus);
    --rdp-range_middle-background-color: color-mix(in srgb, var(--tkf-line-focus) 14%, transparent);
    --rdp-today-color: var(--tkf-fg);
    margin: 0;
    font-family: inherit;
  }

  .tankef-rdp .rdp-month_caption {
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--tkf-fg);
    text-transform: capitalize;
    padding: 0 0 0.75rem 0;
  }

  .tankef-rdp .rdp-button_previous,
  .tankef-rdp .rdp-button_next {
    border-radius: 6px;
    border: 1px solid var(--tkf-line);
    color: var(--tkf-fg);
  }

  .tankef-rdp .rdp-button_previous:hover:not(:disabled),
  .tankef-rdp .rdp-button_next:hover:not(:disabled) {
    background-color: var(--tkf-surface-muted);
  }

  .tankef-rdp .rdp-chevron {
    fill: var(--tkf-fg);
  }

  .tankef-rdp .rdp-weekday {
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--tkf-fg-muted);
    text-transform: capitalize;
  }

  .tankef-rdp .rdp-day_button {
    font-size: 0.875rem;
    color: var(--tkf-fg);
  }

  .tankef-rdp .rdp-day_button:hover:not(:disabled) {
    background-color: var(--tkf-surface-muted);
  }

  .tankef-rdp .rdp-today .rdp-day_button {
    font-weight: 600;
    background-color: var(--tkf-surface-muted);
  }

  .tankef-rdp .rdp-selected .rdp-day_button {
    background-color: var(--tkf-line-focus);
    color: var(--tkf-fg-inverse);
    font-weight: 500;
  }

  .tankef-rdp .rdp-selected .rdp-day_button:hover {
    background-color: color-mix(in srgb, var(--tkf-line-focus) 90%, black);
  }

  .tankef-rdp .rdp-range_middle .rdp-day_button {
    background-color: transparent;
    color: var(--tkf-fg);
  }

  .tankef-rdp .rdp-range_middle .rdp-day_button:hover {
    background-color: color-mix(in srgb, var(--tkf-line-focus) 22%, transparent);
  }

  .tankef-rdp .rdp-outside .rdp-day_button {
    color: var(--tkf-fg-subtle);
  }

  .tankef-rdp .rdp-disabled .rdp-day_button {
    color: var(--tkf-fg-disabled);
  }

  .tankef-rdp .rdp-dropdowns {
    gap: 0.5rem;
  }

  .tankef-rdp .rdp-dropdown_root {
    border-radius: 6px;
  }

  .tankef-rdp select.rdp-dropdown {
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--tkf-fg);
    background-color: var(--tkf-surface);
    border: 1px solid var(--tkf-line);
    border-radius: 6px;
    padding: 0.125rem 0.375rem;
  }
`;
